module.exports = __webpack_public_path__ + "img/profitForecastNo2.11845d5e.png";